import React from 'react';
import Icon from '../../../components/AppIcon';

const LeaderboardCard = ({ leaderboard, showFull = false }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const getRankIcon = (rank) => {
    switch (rank) {
      case 1:
        return <Icon name="Crown" size={16} className="text-warning" />;
      case 2:
        return <Icon name="Medal" size={16} className="text-muted-foreground" />;
      case 3:
        return <Icon name="Award" size={16} className="text-accent" />;
      default:
        return <span className="text-sm font-medium text-muted-foreground">#{rank}</span>;
    }
  };

  const displayData = showFull ? leaderboard : leaderboard?.slice(0, 5);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground flex items-center space-x-2">
          <Icon name="Trophy" size={20} className="text-warning" />
          <span>Leaderboard</span>
        </h3>
        {!showFull && leaderboard?.length > 5 && (
          <button className="text-sm text-primary hover:text-primary/80 transition-micro">
            View all
          </button>
        )}
      </div>
      <div className="space-y-3">
        {displayData?.map((participant, index) => (
          <div 
            key={participant?.id}
            className={`flex items-center justify-between p-3 rounded-lg transition-micro ${
              index < 3 ? 'bg-muted/50' : 'hover:bg-muted/30'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8">
                {getRankIcon(index + 1)}
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-medium">
                  {participant?.name?.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-card-foreground">
                    {participant?.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {participant?.donationCount} donations
                  </p>
                </div>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-card-foreground">
                {formatAmount(participant?.totalAmount)}
              </p>
              {participant?.badges && participant?.badges?.length > 0 && (
                <div className="flex items-center space-x-1 mt-1">
                  {participant?.badges?.slice(0, 2)?.map((badge, badgeIndex) => (
                    <span 
                      key={badgeIndex}
                      className="text-xs px-1 py-0.5 bg-accent/10 text-accent rounded"
                    >
                      {badge}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {showFull && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="text-center text-sm text-muted-foreground">
            Total participants: {leaderboard?.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardCard;